/**
 * Eingeschränkte Bearbeitungsrechte auf Betriebs- und Anlagendaten.
 */
export const BETREIBER = "BETREIBER";
/**
 * Eingeschränkte Bearbeitungsrechte auf Betriebs- und Anlagendaten.
 * Kein Zugriff auf Betreiberverwaltung.
 */
export const BEAUFTRAGTER = "BEAUFTRAGTER";
/**
 * Leserechte auf Fachobjekte. Kein Zugriff auf Betreiberverwaltung.
 */
export const LESER_ORGANISATION = "LESER_ORGANISATION";
/**
 * Leserechte auf Bescheids-, SÜVOA- und AbwAG-Daten.
 */
export const ZUST_SBD = "ZUST_SBD";
/**
 * Leserechte auf Anlagen-, SÜVOA- und AbwAG-Daten. Kein Zugriff auf Betreiberverwaltung.
 */
export const ZUST_SBB = "ZUST_SBB";
/**
 * Leserechte auf Anlagen-, Bescheids- und AbwAG-Daten. Kein Zugriff auf Betreiberverwaltung.
 */
export const ZUST_SBS = "ZUST_SBS";
/**
 * Leserechte auf Anlagen-, Bescheids- und SÜVOA-Daten. Kein Zugriff auf Betreiberverwaltung.
 */
export const ZUST_SBA = "ZUST_SBA";
/**
 * Leserechte auf Fachobjekte. Kein Zugriff auf Betreiberverwaltung.
 */
export const LESER_BEHOERDE = "LESER_BEHOERDE";
/**
 * Kein Zugriff auf „Systemverwaltung“.
 */
export const FACHADMIN = "FACHADMIN";
/**
 * Keine Einschränkungen.
 */
export const SYSTEMADMIN = "SYSTEMADMIN";
